export default __webpack_public_path__ + "static/grid-cloud-b721d4f6da38d7ba053c78e1fe4946e2.mp4";